module.exports = __webpack_public_path__ + "static/media/moderl-layout.bbdecc8f.jpg";